<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-05-19 17:03:37
 * @FilePath: \gcp-fe\src\app\noticesList\components\list.vue
 * @Description: 通知公告与政策法规----更多
-->
<template>
  <div style="width: 1180px;margin: 0 auto;">
    <base-bread-crumb
      class="bread-crumb"
      :currBreadCrumb="currBreadCrumb"
      :isShowPortal="true"
    ></base-bread-crumb>
    <div class="ccui-app-container">
      <div class="ccui-advanced-search-wrapper ccui-clearfix">
        <el-search
          width="460px"
          ref="search"
          :formProp="formData"
          @search="search"
          :isShowSearch="true"
          :selectClear="true"
          class="ccui-highsearch no-print marginB"
          @resetForm="resetForm"
        >
          <template slot="search">
            <el-input
              v-model.trim="formData.title"
              clearable
              searchLabel="标题"
              placeholder="请输入标题"
            ></el-input>
            <el-date-picker
              v-model="formData.publishTime"
              searchLabel="发布时间"
              clearable
              type="daterange"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              range-separator="至"
              start-placeholder="请选择"
              end-placeholder="请选择"
            ></el-date-picker>
          </template>
          <el-input
            v-model.trim="formData.title"
            clearable
            searchLabel="标题"
            placeholder="请输入标题"
            slot="searchItem1"
          ></el-input>
          <el-date-picker
            v-model="formData.publishTime"
            searchLabel="发布时间"
            clearable
            type="daterange"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            range-separator="至"
            start-placeholder="请选择"
            end-placeholder="请选择"
            slot="searchItem4"
          ></el-date-picker>
        </el-search>
      </div>
      <div class="ccui-multifunctional-table-wrapper">
        <el-table
          ref="multipleTable"
          :data="tableData"
          :fit="true"
          border
          style="width: 1180px;margin: 0 auto;"
          class="ccui-multifunctional-table"
          @header-dragend="tableTitleWidth"
          tooltip-effect="light"
        >
          <el-table-column label="序号" width="60">
            <template scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="title"
            v-if="routeType == 'noticeType'"
            label="公告名称"
            width="380"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">
              <a @click="handleView(row)" class="a-line">{{ row.title }}</a>
            </template>
          </el-table-column>
          <el-table-column
            prop="title"
            v-if="routeType == 'lawType'"
            label="标题"
            width="380"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">
              <a @click="handleView(row)" class="a-line">{{ row.title }}</a>
            </template>
          </el-table-column>
          <el-table-column label="发布时间" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.publishTime }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="ccui-table-footer" v-if="tableData.length != 0">
          <div id="ccui-paging">
            <el-pagination
              :total="numTotal"
              :page-size="pageSizeCode"
              :current-page="pageNo"
              :page-sizes="[10, 20, 50, 100, 200, 500]"
              prev-text="< 上一页"
              next-text="下一页 >"
              background
              layout="total, sizes, prev, pager, next, jumper"
              popper-class="ccui-paging-page-size-popper"
              @prev-click="handlePrev"
              @next-click="handleNext"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
            <el-button
              class="ccui-pagination-btn"
              size="mini"
              type="default"
              @click="handleSizeChange('none')"
              >确定</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { qryNoticeInfoPageList, updateNoticeHits } from "../api/index";
import BaseBreadCrumb from "../components/baseBreadCrumb";
export default {
  name: "announcement-list-revoked",
  components: {
    BaseBreadCrumb
  },
  data() {
    return {
      currBreadCrumb: [
        {
          title: "通知公告"
        }
      ],
      sort: "",
      accessory: [], //附件
      dialogVisibleSort: false,
      focuses: [
        { focus: "unpublished" },
        { focus: "published" },
        { focus: "revoked" }
      ],
      creatorName: "",
      title: "",
      textContent: "",
      isActive: 1,
      multiDataToEnd: {},
      singleDataToEnd: {},
      // 表格数据
      tableData: [],
      // 表格命名
      tableName: "announcementPublishedTableName",
      // 表格数据
      tableThead: [],
      // 锁定表格
      fixedTableThead: [
        {
          label: "序号",
          prop: "demoId",
          width: 40,
          checked: true,
          fixed: true
        }
      ],
      // 非锁定表格
      tableTheadOptions: [{ label: "标题", prop: "title", minWidth: "130" }],
      dialogTableVisible: false,
      isFocus: 1,
      isSelection: false,
      numTotal: 0,
      // 高级搜索数据 start
      // 高级搜索提交数据
      formData: {},
      currentView: "",
      myWidth: 0,
      btncolor: [],
      isShow: false,
      value: "",
      searchBtnStatus: "single",
      pageNo: 1,
      // 筛选字段调用函数集合
      filterMethodList: {
        filterHandler: (value, row, column) => {
          const property = column["property"];
          return row[property] === value;
        }
      },
      form: {
        noticeId: null,
        cancelReason: ""
      },
      dialogVisible: false,
      pid: "100021",
      appIdG: "",
      rules: {
        cancelReason: [
          { required: true, message: "请输入撤销理由", trigger: "blur" }
        ]
      },
      pageSizeCode: 10,
      tableNamePageName: "announcementPublishedPageName",
      routeType: "noticeType",
      type: 100102 //通知公告
    };
  },
  activated() {
    this.qryNoticeInfoPageList();
  },
  deactivated() {
    this.pageSizeCode = 20;
    let pageSizeObj = {};
    pageSizeObj[this.tableNamePageName] = 20;
    localStorage.setItem(this.tableNamePageName, JSON.stringify(pageSizeObj));
  },
  mounted() {
    this.setTableWidth();
    this.appIdG = process.env.VUE_APP_ID;
    if (this.$route.query.type) {
      this.routeType = this.$route.query.type;
      if (this.routeType == "noticeType") {
        this.currBreadCrumb = [{ title: "通知公告" }];
        this.type = 100102;
      } else if (this.routeType == "lawType") {
        this.currBreadCrumb = [{ title: "政策法规" }];
        this.type = 100106;
      }
    }
  },
  beforeMount() {},
  methods: {
    resetForm() {
      this.formData = {
        title: "",
        publishTime: ""
      };
    },
    search(searchData) {
      this.pageNo = 1;
      this.formDataSearch = searchData;
      this.localSearchData = JSON.parse(JSON.stringify(searchData));
      sessionStorage.setItem("pageNo", this.tableName, {
        pageNo: this.pageNo,
        searchForm: this.localSearchData
      });
      this.qryNoticeInfoPageList(this.formDataSearch);
    },
    qryNoticeInfoPageList(reqObj) {
      let obj = {};
      if (this.formData != undefined) {
        this.formData.publishTimeStar =
          this.formData.publishTime && this.formData.publishTime[0]
            ? this.formData.publishTime[0]
            : "";
        this.formData.publishTimeEnd =
          this.formData.publishTime && this.formData.publishTime[0]
            ? this.formData.publishTime[1]
            : "";
      }
      obj = {
        type: this.type,
        status: 2,
        pageNo: this.pageNo,
        pageSize: this.pageSizeCode,
        isShowLoading: true,
        ...this.formData
      };
      qryNoticeInfoPageList(obj)
        .then(res => {
          //处理一下 一整页的删除 之后数据是空白的问题
          if (res.data.data.rows.length == 0 && this.pageNo > 1) {
            this.pageNo--; //自减一页
            //重新自调用接口
            this.qryNoticeInfoPageList();
            return;
          }
          this.tableData = res.data.data.rows;
          this.tableData.forEach(item => {
            item.statusStr = "已发布";
          });
          this.numTotal = res.data.data.recordsTotal;
          this.pageNo = res.data.data.pageNo; // 当前页
          this.$nextTick(() => {
            this.$store.commit("SET_PAGELOADING", false);
            this.$store.dispatch("setPageLoading", false);
          });
        })
        .catch(e => {});
    },
    // 表格宽度更改存入
    tableTitleWidth(newWidth, oldWidth, column, event) {
      for (let i = 0; i < this.tableTheadOptions.length; i++) {
        if (this.tableTheadOptions[i].label === column.label) {
          this.tableTheadOptions[i].width = newWidth;
        }
      }
      const comment = JSON.stringify(this.tableTheadOptions);
      localStorage.setItem(this.tableName, comment);
      this.tableTheadOptions = JSON.parse(localStorage.getItem(this.tableName));
    },
    handlePrev() {},
    handleNext() {},
    handleSizeChange(val) {
      this.pageSizeCode = val;
      this.qryNoticeInfoPageList();
    },
    handleCurrentChange(val) {
      // 跳转翻页都会调这个方法
      this.pageNo = val;
      this.qryNoticeInfoPageList();
    },
    // 渲染本地存储表格宽度
    setTableWidth() {
      const localTableData = JSON.parse(localStorage.getItem(this.tableName));
      if (localTableData) {
        for (let i = 0; i < this.tableTheadOptions.length; i++) {
          if (this.tableTheadOptions[i].label === localTableData[i].label) {
            this.tableTheadOptions[i].width = localTableData[i].width;
          }
        }
      }
    },
    handleView(item) {
      updateNoticeHits({ noticeId: item.id });
      this.$router.push({
        path: "/noticeDetail",
        query: {
          id: item.id,
          type: this.routeType
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
/deep/ .el-search .el-searchs-box {
  margin-bottom: 20px;
}
// /deep/ .padding30 .el-input__inner {
//   padding-left: 30px !important;
// }
// /deep/.el-range-editor.el-input__inner {
//   width: 100%;
// }
// /deep/.el-range-input {
//   font-size: 13px;
// }
// /deep/.ccui-advanced-search-wrapper
//   .ccui-search-wrapper
//   .ccui-search-bar
//   .el-range-editor.el-input__inner {
//   padding: 0;
//   width: 230px !important;
// }
// /deep/ .el-date-range-picker__time-picker-wrap {
//   /deep/ .el-time-panel {
//     margin: 5px -24px !important;
//   }
// }
.div-texrcontent {
  width: 700px;
  height: 721px;
}
.span-text {
  display: inline-block;
  height: 18px;
  font-size: 13px;
  font-family: "PingFangSC-Regular", "PingFang SC";
  font-weight: 400;
  color: rgba(155, 155, 155, 1);
  line-height: 18px;
  margin: 10px 0 15px 0;
}
.span-text {
  margin-right: 10px;
}
.span-text span:nth-child(1) {
  padding-right: 10px;
}
.span-text span > span {
  color: #2e9ff2;
}
.span-volume {
  width: 60px;
  height: 18px;
  font-size: 13px;
  font-family: "PingFangSC-Regular", "PingFang SC";
  font-weight: 400;
  color: rgba(155, 155, 155, 1);
  line-height: 18px;
}
.el-dialog {
  width: 780px;
}
.el-dialog__header {
  width: 100%;
  height: 43px;
}
.el-dialog__footer {
  width: 100%;
  height: 58px;
}
.el-dialog__footer > el-button {
  width: 57px;
  height: 28px;
  line-height: 28px;
  font-size: 13px;
  font-family: "PingFang-SC-Medium", "PingFang-SC";
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
}
.div-text {
  width: 700px;
  // height: 270px;
  font-size: 16px;
  font-family: "PingFangSC-Regular", "PingFang SC";
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  line-height: 30px;
}
.div-text img {
  width: 100%;
}
.div-accessory {
  display: flex;
  margin-top: 40px;
}
.div-accessory .div-accessory-left {
  width: 39px;
  height: 18px;
  font-size: 13px;
  font-family: "PingFangSC-Regular", "PingFang SC";
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  line-height: 18px;
}
.div-accessory .div-accessory-right {
  font-size: 13px;
  font-family: "PingFangSC-Regular", "PingFang SC";
  font-weight: 400;
  color: rgba(0, 137, 239, 1);
  line-height: 18px;
}
.div-accessory .div-accessory-right > p {
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::-webkit-scrollbar {
  width: 10px;
}
.red {
  color: #d5090b;
}
// 富文本预览展示表格线问题
.div-texrcontent {
  /deep/ table {
    border-collapse: collapse;
  }
  /deep/ ul,
  /deep/ ol {
    padding-left: 18px;
  }
}
.searchBtn {
  float: right;
}
.searchBtn {
  .ml10 {
    float: right;
    margin-left: 10px;
  }
}
.revokedDIalog {
  /deep/ .el-dialog__footer .el-button.el-button--primary-font-mini {
    background-color: #ff5000 !important;
    border-color: #ff5000 !important;
  }
  /deep/ .el-dialog__body {
    padding: 20px;
  }
  /deep/ .el-textarea .el-textarea__inner {
    resize: none !important; //主要是这个样式
    padding: 5px 10px;
    padding-bottom: 0px;
    overflow: auto;
    height: 90px;
    font-size: 13px;
  }
  /deep/ .el-textarea .el-input__count {
    right: 10px;
  }
}
// .ccui-advanced-search-wrapper .ccui-search-btn {
//   color: #ff5000 !important;
// }
/deep/
  .ccui-advanced-search-wrapper
  .ccui-search-wrapper
  .ccui-search-bar
  .el-range-editor.el-input__inner {
  padding-bottom: 2px;
}
/deep/ .ccui-multifunctional-table-wrapper .el-table .cell {
  white-space: pre;
}
// /deep/ .ccui-advanced-search-wrapper .ccui-search-wrapper .ccui-search-bar {
//   width: 400px;
// }
// 解决高级搜索时间选择器 清空按钮位置偏移问题
/deep/
  .ccui-advanced-search-wrapper
  .ccui-form-wrapper
  .ccui-accurate
  .el-form-item
  .el-form-item__content
  .el-input__icon.el-range__close-icon {
  right: 3px;
  font-size: 13px !important;
}
.bread-crumb {
  padding: 20px 0;
  margin: 0 !important;
}
</style>
